import type { CollectionResponseDtoRarity } from '~/lib/api';

export const getRarityName = (rarity: CollectionResponseDtoRarity) => {
  if (rarity === 'common') return 'Common';
  if (rarity === 'uncommon') return 'Uncommon';
  if (rarity === 'rare') return 'Rare';
  if (rarity === 'ultra_rare') return 'Ultra Rare';
  if (rarity === 'ultimate') return 'Ultimate';
  if (rarity === 'heirloom') return 'Heirloom';
  return 'Legendary';
};
